import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {AiOutlineTag, AiOutlineFlag, AiFillFlag, AiOutlineCaretUp, AiOutlineCaretDown} from 'react-icons/ai';
import {BiCheck, BiCheckCircle} from 'react-icons/bi';
import { MdCalendarToday } from 'react-icons/md';
import ellipsizeText from "./EllipsizeText";
import convertToHourMinute from "./ConvertToHourMinute";

import { getRemainingDays } from './DaysUntilEvent';
import { getSubsubProgress } from './subsubProgress';
import ContextMenu from './MarkAsDoneContextMenu';
import { buildSubsubContextMenuItems } from './subsubContextMenuItems';

const getValidUntilColor = (days) => {
    if (days <= 0) return '#ff2d44';
    if (days < 1) return '#fd7e14';
    if (days < 3) return '#ffc107';
    return '#4dabff';
};


const ActiveStamp = ({currentSubSub, showFlaggedTasksOnly, flaggedDoneSubTasks, flaggedSubTasks,
                    setSubtasksHighlighted, setHighlightedSubSubHelperMemoized, memoizedFlagSubTask,
                subtasksHighlighted, sortSubSubsWithFlaggedSubSubsFirst,
                    timerActive, timer1, timer1InitialValue,
                    taskTimeDisplayMode, showOnlyNonZerosAndCountUp,
                    onMarkSubsubDone,
                    onAdjustSubsubTime}) => {

    const isElapsedMode = taskTimeDisplayMode === 'elapsed'
    
    const onSubSubClick = async (currentSubSub, it) => {
        try {
            setIsShimmering(true)
            if (onMarkSubsubDone) {
                await onMarkSubsubDone(currentSubSub, it)
            }
        } finally {
            setIsShimmering(false)
        }
    }

    const [isShimmering, setIsShimmering] = useState(false)
    const [contextMenu, setContextMenu] = useState({ visible: false, anchorRect: null, subsub: null })

    const handleContextMenu = (e, subsub) => {
        e.preventDefault()
        e.stopPropagation()
        const rect = e.currentTarget.getBoundingClientRect()
        setContextMenu({
            visible: true,
            anchorRect: { left: rect.left, top: rect.top, bottom: rect.bottom, width: rect.width },
            subsub
        })
    }

    const closeContextMenu = () => {
        setContextMenu((prev) => ({ ...prev, visible: false }))
    }

    const adjustCurrentSubsubTime = async (action) => {
        if (!contextMenu.subsub || !onAdjustSubsubTime) {
            return
        }
        try {
            setIsShimmering(true)
            await onAdjustSubsubTime(currentSubSub, contextMenu.subsub, action)
        } finally {
            setIsShimmering(false)
        }
    }

    const subsubContextMenuItems = buildSubsubContextMenuItems({
        onMarkDone: async () => {
            if (contextMenu.subsub) {
                await onSubSubClick(currentSubSub, contextMenu.subsub)
            }
        },
        onAdjustTime: async (action) => {
            await adjustCurrentSubsubTime(action)
        }
    })

    const getSubsubProgressStyle = (workedRatio) => {
        const percent = workedRatio * 100
        return {
            '--progress-percent': `${percent}%`
        }
    }
    
    return(
        <>
            <div className='SubTaskActive'>
                
                {currentSubSub.hasOwnProperty('subsubs') && sortSubSubsWithFlaggedSubSubsFirst(currentSubSub.subsubs).map((it) => { 
                    if (showFlaggedTasksOnly && (flaggedDoneSubTasks.indexOf(currentSubSub.sname + it.name) > -1 || flaggedSubTasks.indexOf(currentSubSub.sname + it.name) == -1))
                    {
                        return null
                    }
                    const plannedUnits = Number(it.initialFinish ?? it.time ?? it.finish ?? 0) || 0
                    if (showOnlyNonZerosAndCountUp && plannedUnits < 0.000001) {
                        return null
                    } else {
                        const subsubKey = `${currentSubSub.sname}/${it.name}`
                        const isActiveSubsub = subsubKey === subtasksHighlighted
                        const description = typeof it.description === 'string' ? it.description : ''
                        const hasDescription = description.trim() !== ''
                        const elapsedMsRaw = timerActive === 1 ? (Number(timer1InitialValue) - Number(timer1)) : 0
                        const elapsedMs = Number.isFinite(elapsedMsRaw) ? elapsedMsRaw : 0
                        const elapsedUnits = isActiveSubsub && elapsedMs > 0
                            ? 0.5 * elapsedMs / (25 * 60 * 1000)
                            : 0
                        const progress = getSubsubProgress(it, elapsedUnits)
                        const subsubProgressStyle = getSubsubProgressStyle(progress.workedRatio)
                        const isCompleted = progress.workedRatio >= 1
                        const remainingMinutes = progress.remainingDisplay * 50
                        const elapsedMinutes = Math.max(0, (progress.planned - progress.remainingDisplay) * 50)
                        const minutesToDisplay = isElapsedMode ? elapsedMinutes : remainingMinutes
                        const shouldShowTime = progress.planned > 0 && (remainingMinutes >= 1 || elapsedMinutes >= 1)
                        return (
                            <React.Fragment key={it.sn || it.name}>
                            <div style={{...subsubProgressStyle, position: 'relative'}} className={`${isActiveSubsub ? 'highlightedSubtask' : 'subtaskEntry'}  ${it.name.startsWith('*') && (!it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'green' : 
                            ((it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'yellow' : (  it.name.startsWith('***') ? 'red' : ''  ))} `}>
                                <span className={`subtaskFlag`} onClick={() => memoizedFlagSubTask(currentSubSub.sname, it.name)}> {flaggedSubTasks.indexOf(currentSubSub.sname + it.name) == -1 ? <AiOutlineFlag></AiOutlineFlag> : (flaggedDoneSubTasks.indexOf(currentSubSub.sname + it.name) == -1 ? <AiFillFlag></AiFillFlag> : <BiCheck></BiCheck>)} </span> <span className={`${isShimmering ? 'shimmer' : ''}`} onClick={() => {subsubKey === subtasksHighlighted ? setSubtasksHighlighted("") : setHighlightedSubSubHelperMemoized(subsubKey)}} onContextMenu={(e) => handleContextMenu(e, it)}  >{it.name.replace(/#|\*/g,'')}</span>{' '}
                                {shouldShowTime && (
                                    <>
                                        <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                                            {convertToHourMinute(minutesToDisplay)}
                                            <span style={{ marginLeft: 2 }}>
                                                {isElapsedMode ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                                            </span>
                                        </span>
                                    </>
                                )}
                                {(it.expiryDate || it.validUntil) && (
                                    <>
                                        {shouldShowTime && ' / '}
                                        <span style={{opacity: 0.8, color: getValidUntilColor(getRemainingDays(it.expiryDate || it.validUntil))}}>
                                            {getRemainingDays(it.expiryDate || it.validUntil).toFixed(1)} <MdCalendarToday style={{ marginLeft: 1 }} />
                                        </span>
                                    </>
                                )}
                                {isCompleted && (
                                    <>
                                        <span style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: 0,
                                            bottom: 0,
                                            width: '60px',
                                            background: 'linear-gradient(to right, transparent, rgba(45, 55, 72, 1) 70%)',
                                            pointerEvents: 'none',
                                            borderRadius: '0 3px 3px 0'
                                        }}></span>
                                        <span style={{position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', color: '#48BB78', fontSize: '1.1em'}}><BiCheckCircle /></span>
                                    </>
                                )}
                            </div>
                            {isActiveSubsub && hasDescription && (
                                <div className="SubSubTaskDescription">
                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{description}</ReactMarkdown>
                                </div>
                            )}
                            </React.Fragment>
                        )
                    }
                    })}   
            </div>
            {currentSubSub.tags && currentSubSub.tags !== '' && <div className="TagAreaOfSubTask">
                    <AiOutlineTag style={{marginRight: 10}}></AiOutlineTag> <span>{
                        currentSubSub.tags? currentSubSub.tags.split(',').map((t) => {
                            return(<span className={`tag ${t}`}>{ellipsizeText(t,3)}</span>)
                        }) : ''
                    }</span>
            </div>}
            <ContextMenu 
                visible={contextMenu.visible}
                anchorRect={contextMenu.anchorRect}
                onClose={closeContextMenu}
                menuItems={subsubContextMenuItems}
            />
        </>
    )
}

export default React.memo(ActiveStamp);
